import { useContext } from 'react';
import { getContext } from '../utils';
import { Context } from '../components/transform-context';

const useTransformContext = () => {
  const libraryContext = useContext(Context);
  if (!libraryContext.contextInstance) {
    throw new Error('Transform context mus be placed inside TransformWrapper');
  }
  return getContext(libraryContext.contextInstance);
};

export default useTransformContext;
